/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Tue Mar 07 2023
 **/

import { DependencyList } from "react";
import useEventHandler from "./useEventHandler";
import type { EventName, Handler } from "./eventhandler";

type Events = {
	[eventName: EventName]: Handler;
};

export default function useEventHandlers(events: Events, deps: DependencyList = []) {
	for (const [name, callback] of Object.entries(events)) {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		useEventHandler(name, callback, deps);
	}
}
